var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJacket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3797D3"
    },
    d: "M323.768,95.672H188.232c-10.345,0-18.732-8.387-18.732-18.732V18.732 C169.501,8.387,177.888,0,188.232,0h135.535c10.345,0,18.732,8.387,18.732,18.732V76.94 C342.499,87.285,334.112,95.672,323.768,95.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4881C2"
    },
    d: "M323.768,0H256v95.672h67.768c10.345,0,18.732-8.387,18.732-18.732V18.732 C342.499,8.387,334.112,0,323.768,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M345.662,58.206H166.338c-80.002,0-146.544,64.785-146.544,146.532v190.514 c0,10.34,8.392,18.732,18.732,18.732h75.551v79.285c0,10.34,8.379,18.732,18.732,18.732h246.384 c10.352,0,18.732-8.392,18.732-18.732v-79.285h75.551c10.34,0,18.732-8.392,18.732-18.732V204.738 C492.207,122.996,425.683,58.206,345.662,58.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3797D3"
    },
    d: "M345.662,58.206H256V512h123.192c10.352,0,18.732-8.392,18.732-18.732v-79.285h75.551 c10.34,0,18.732-8.392,18.732-18.732V204.738C492.207,122.996,425.683,58.206,345.662,58.206z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.268,
    y: 58.206,
    style: {
      fill: "#4881C2"
    },
    width: 37.463,
    height: 453.794
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4881C2"
    },
    d: "M95.332,175.828c-10.34,0-18.732,8.392-18.732,18.732v126.685H19.793v37.463H76.6v55.275h37.463 V194.56C114.064,184.22,105.684,175.828,95.332,175.828z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 58.206,
    style: {
      fill: "#2F66A3"
    },
    width: 18.732,
    height: 453.794
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F66A3"
    },
    d: "M492.207,321.245h-56.813V194.563c0-10.345-8.387-18.732-18.732-18.732 c-10.345,0-18.732,8.387-18.732,18.732v219.414h37.463v-55.269h56.813V321.245z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacket);
export default __webpack_public_path__ + "static/media/jacket.4a68dc75e9584526b792040f19cd4493.svg";
export { ForwardRef as ReactComponent };